import React, { useEffect } from "react";
import StoryRepliesCharts from "./StoryRepliesCharts";
import NoData from "../NoData/NoData";
import Loading from "../Loading/Loading";
function StoryReplies(props) {
    const chartLoading = props.chartDataLoading?.insta_story_replies;
    const isNoData = props.pageStatus || props.chartData?.insta_story_replies?.nodata;
    useEffect(() => {
        props.setIsNoDataState(isNoData);
    }, [props.chartData, props.pageStatus]);
    return (
        <>
            {chartLoading && <Loading />}
            {!isNoData && !chartLoading && (
                <StoryRepliesCharts
                    chartData={props.chartData.insta_story_replies}
                    showLegend={props.showLegend}
                    showGridLines={props.showGridLines}
                    showLabel={props.showLabel}
                    graphType={props.graphType}
                    isIGPage={props.isIGPage}
                    widgetContainerRef={props.widgetContainerRef}
                    showAverage={props.showAverage}
                />
            )}
            {isNoData && !chartLoading && <NoData message={props.pageStatus ? "Page is Inactive. Please re-authenticate" : ""} />}
        </>
    );
}
export default StoryReplies;
